import React from 'react'

import { localizedTranslate } from 'assets/localization'
import { connect } from 'react-redux'





import 'less/unsubscribeSuccessfully.less'

function mapStateToProps(state) {
  return {
    t: localizedTranslate('en', state.translations.en_us)
  }
}

const UnSubscribedSuccessfully = (props) => {




  return (
    <div>
      <div className="top" >
        <div className="top-line"></div>
      </div>
      <div className="unsubscribe-msg">
        <div class="unsubscribe-msg-text">
          {props.t('unsubscribe.action.success')}
        </div>


      </div>
      <div className='main-apollo-logo-subscribe' />
      <div className="footer" >
        <div className="footer-line"></div>
      </div>
    </div>
  )
}



export default connect(mapStateToProps)(UnSubscribedSuccessfully)
